import { useSelector } from "react-redux";
import { getNotifMsg } from "utils/message";

const getLocale = ({ settingsData }) => settingsData.locale;

function PageLazyLoadFallback() {
  const locale = useSelector(getLocale);

  return (
    <div className="loader_container conv__body">
      <div className="flex w-100 flex-jc-c">
        {getNotifMsg("ROUTER_FALLBACK_TEXT", locale)}
      </div>
    </div>
  );
}

export default PageLazyLoadFallback;
